import styles from './Loading.module.scss'

const Loading = () => {
    return (
        <div data-testid="loading" className={styles.container}>
            <div className={styles.spinner} />
        </div>
    )
}

export default Loading
